<div class="ab-account-cards">
  <ab-deploy-cards
    [deployData]="deployData"
    [statData]="statData"
    [dur]="dur"
  ></ab-deploy-cards>
</div>
<ab-deploy-chart [statData]="statData" [loading]="loading"></ab-deploy-chart>
<ng-container *ngIf="deployData?.count > 0">
  <h4 class="mt-3">Deploys with the most new errors</h4>
  <ab-deploys-with-errors
    [deployData]="deployData"
    [project]="project"
    [loading]="loading"
  ></ab-deploys-with-errors>
</ng-container>
